'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dRule$002dKind$0024$0024anon$0024106 from "./presto.types$-Rule-Kind$$anon$106.js";
var $p;
/** @constructor */
function $c_Lpresto_types$RuleKind$$anon$109(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$RuleKind$$anon$109 as $c_Lpresto_types$RuleKind$$anon$109 };
$p = $c_Lpresto_types$RuleKind$$anon$109.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$RuleKind$$anon$109;
/** @constructor */
function $h_Lpresto_types$RuleKind$$anon$109() {
}
export { $h_Lpresto_types$RuleKind$$anon$109 as $h_Lpresto_types$RuleKind$$anon$109 };
$h_Lpresto_types$RuleKind$$anon$109.prototype = $p;
$p.bN = (function(text) {
  try {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($m_Lpresto_types$RuleKind$().cwy(text));
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.cAS = (function(it) {
  try {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(it.l());
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.bJ = (function(t) {
  return this.cAS(t);
});
var $d_Lpresto_types$RuleKind$$anon$109 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$RuleKind$$anon$109, "presto.types$RuleKind$$anon$109", ({
  a1m: 1,
  K: 1
}));
export { $d_Lpresto_types$RuleKind$$anon$109 as $d_Lpresto_types$RuleKind$$anon$109 };
function $s_Lpresto_types$RuleKind$__Allow__Lpresto_types$RuleKind() {
  $m_Lpresto_types$RuleKind$();
  return $t_Lpresto_types$RuleKind$__Allow;
}
export { $s_Lpresto_types$RuleKind$__Allow__Lpresto_types$RuleKind as $s_Lpresto_types$RuleKind$__Allow__Lpresto_types$RuleKind };
function $s_Lpresto_types$RuleKind$__Ip__Lpresto_types$RuleKind() {
  $m_Lpresto_types$RuleKind$();
  return $t_Lpresto_types$RuleKind$__Ip;
}
export { $s_Lpresto_types$RuleKind$__Ip__Lpresto_types$RuleKind as $s_Lpresto_types$RuleKind$__Ip__Lpresto_types$RuleKind };
function $s_Lpresto_types$RuleKind$__TimeRange__Lpresto_types$RuleKind() {
  $m_Lpresto_types$RuleKind$();
  return $t_Lpresto_types$RuleKind$__TimeRange;
}
export { $s_Lpresto_types$RuleKind$__TimeRange__Lpresto_types$RuleKind as $s_Lpresto_types$RuleKind$__TimeRange__Lpresto_types$RuleKind };
function $s_Lpresto_types$RuleKind$__DaysInWeek__Lpresto_types$RuleKind() {
  $m_Lpresto_types$RuleKind$();
  return $t_Lpresto_types$RuleKind$__DaysInWeek;
}
export { $s_Lpresto_types$RuleKind$__DaysInWeek__Lpresto_types$RuleKind as $s_Lpresto_types$RuleKind$__DaysInWeek__Lpresto_types$RuleKind };
/** @constructor */
function $c_Lpresto_types$RuleKind$() {
  this.caF = null;
  this.caG = false;
  this.caD = null;
  this.caE = false;
  this.caH = null;
  this.caI = false;
  this.caJ = null;
  this.caK = false;
  $n_Lpresto_types$RuleKind$ = this;
  $t_Lpresto_types$RuleKind$__Allow = new $j_presto$002etypes$0024$002dRule$002dKind$0024$0024anon$0024106.$c_Lpresto_types$RuleKind$$anon$106(0, "Allow", this);
  $t_Lpresto_types$RuleKind$__Ip = new $j_presto$002etypes$0024$002dRule$002dKind$0024$0024anon$0024106.$c_Lpresto_types$RuleKind$$anon$106(1, "Ip", this);
  $t_Lpresto_types$RuleKind$__TimeRange = new $j_presto$002etypes$0024$002dRule$002dKind$0024$0024anon$0024106.$c_Lpresto_types$RuleKind$$anon$106(2, "TimeRange", this);
  $t_Lpresto_types$RuleKind$__DaysInWeek = new $j_presto$002etypes$0024$002dRule$002dKind$0024$0024anon$0024106.$c_Lpresto_types$RuleKind$$anon$106(3, "DaysInWeek", this);
  $s_Lpresto_types$RuleKind$__Allow__Lpresto_types$RuleKind();
  $s_Lpresto_types$RuleKind$__Ip__Lpresto_types$RuleKind();
  $s_Lpresto_types$RuleKind$__TimeRange__Lpresto_types$RuleKind();
  $s_Lpresto_types$RuleKind$__DaysInWeek__Lpresto_types$RuleKind();
}
export { $c_Lpresto_types$RuleKind$ as $c_Lpresto_types$RuleKind$ };
$p = $c_Lpresto_types$RuleKind$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$RuleKind$;
/** @constructor */
function $h_Lpresto_types$RuleKind$() {
}
export { $h_Lpresto_types$RuleKind$ as $h_Lpresto_types$RuleKind$ };
$h_Lpresto_types$RuleKind$.prototype = $p;
$p.cwy = (function(\u03b4name) {
  switch (\u03b4name) {
    case "Allow": {
      return $s_Lpresto_types$RuleKind$__Allow__Lpresto_types$RuleKind();
      break;
    }
    case "Ip": {
      return $s_Lpresto_types$RuleKind$__Ip__Lpresto_types$RuleKind();
      break;
    }
    case "TimeRange": {
      return $s_Lpresto_types$RuleKind$__TimeRange__Lpresto_types$RuleKind();
      break;
    }
    case "DaysInWeek": {
      return $s_Lpresto_types$RuleKind$__DaysInWeek__Lpresto_types$RuleKind();
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IllegalArgumentException(), ("enum case not found: " + \u03b4name));
    }
  }
});
$p.a2D = (function() {
  if ((!this.caG)) {
    this.caF = new $c_Lpresto_types$RuleKind$$anon$107(this);
    this.caG = true;
  }
  return this.caF;
});
$p.SM = (function() {
  if ((!this.caE)) {
    this.caD = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$14(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((str) => {
      try {
        return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($m_Lpresto_types$RuleKind$().cwy(str));
      } catch (e) {
        var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
        if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
          return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
        } else {
          throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
        }
      }
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa);
    this.caE = true;
  }
  return this.caD;
});
$p.cIA = (function() {
  if ((!this.caI)) {
    this.caH = new $c_Lpresto_types$RuleKind$$anon$108(this);
    this.caI = true;
  }
  return this.caH;
});
$p.csv = (function() {
  if ((!this.caK)) {
    this.caJ = new $c_Lpresto_types$RuleKind$$anon$109(this);
    this.caK = true;
  }
  return this.caJ;
});
var $d_Lpresto_types$RuleKind$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$RuleKind$, "presto.types$RuleKind$", ({
  a1i: 1,
  e: 1,
  G: 1
}));
export { $d_Lpresto_types$RuleKind$ as $d_Lpresto_types$RuleKind$ };
var $n_Lpresto_types$RuleKind$;
function $m_Lpresto_types$RuleKind$() {
  if ((!$n_Lpresto_types$RuleKind$)) {
    $n_Lpresto_types$RuleKind$ = new $c_Lpresto_types$RuleKind$();
  }
  return $n_Lpresto_types$RuleKind$;
}
export { $m_Lpresto_types$RuleKind$ as $m_Lpresto_types$RuleKind$ };
/** @constructor */
function $c_Lpresto_types$RuleKind$$anon$107(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$RuleKind$$anon$107 as $c_Lpresto_types$RuleKind$$anon$107 };
$p = $c_Lpresto_types$RuleKind$$anon$107.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$RuleKind$$anon$107;
/** @constructor */
function $h_Lpresto_types$RuleKind$$anon$107() {
}
export { $h_Lpresto_types$RuleKind$$anon$107 as $h_Lpresto_types$RuleKind$$anon$107 };
$h_Lpresto_types$RuleKind$$anon$107.prototype = $p;
$p.a1 = (function(a) {
  $m_Lpresto_types$RuleKind$();
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Json$();
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Json$JString(a.l());
});
var $d_Lpresto_types$RuleKind$$anon$107 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$RuleKind$$anon$107, "presto.types$RuleKind$$anon$107", ({
  a1k: 1,
  a: 1,
  k: 1
}));
export { $d_Lpresto_types$RuleKind$$anon$107 as $d_Lpresto_types$RuleKind$$anon$107 };
/** @constructor */
function $c_Lpresto_types$RuleKind$$anon$108(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$RuleKind$$anon$108 as $c_Lpresto_types$RuleKind$$anon$108 };
$p = $c_Lpresto_types$RuleKind$$anon$108.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$RuleKind$$anon$108;
/** @constructor */
function $h_Lpresto_types$RuleKind$$anon$108() {
}
export { $h_Lpresto_types$RuleKind$$anon$108 as $h_Lpresto_types$RuleKind$$anon$108 };
$h_Lpresto_types$RuleKind$$anon$108.prototype = $p;
$p.cA = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.cy = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.cq = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.cr = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.cI = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.cz = (function(other) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.b4 = (function(x, y) {
  $m_Lpresto_types$RuleKind$();
  var x$1 = x.l();
  var that = y.l();
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__compareTo__T__I(x$1, that);
});
var $d_Lpresto_types$RuleKind$$anon$108 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$RuleKind$$anon$108, "presto.types$RuleKind$$anon$108", ({
  a1l: 1,
  O: 1,
  a: 1,
  Q: 1,
  U: 1,
  W: 1
}));
export { $d_Lpresto_types$RuleKind$$anon$108 as $d_Lpresto_types$RuleKind$$anon$108 };
var $t_Lpresto_types$RuleKind$__Allow = null;
function $u_Lpresto_types$RuleKind$__Allow(x) {
  $t_Lpresto_types$RuleKind$__Allow = x;
}
export { $t_Lpresto_types$RuleKind$__Allow as $t_Lpresto_types$RuleKind$__Allow, $u_Lpresto_types$RuleKind$__Allow as $u_Lpresto_types$RuleKind$__Allow };
var $t_Lpresto_types$RuleKind$__Ip = null;
function $u_Lpresto_types$RuleKind$__Ip(x) {
  $t_Lpresto_types$RuleKind$__Ip = x;
}
export { $t_Lpresto_types$RuleKind$__Ip as $t_Lpresto_types$RuleKind$__Ip, $u_Lpresto_types$RuleKind$__Ip as $u_Lpresto_types$RuleKind$__Ip };
var $t_Lpresto_types$RuleKind$__TimeRange = null;
function $u_Lpresto_types$RuleKind$__TimeRange(x) {
  $t_Lpresto_types$RuleKind$__TimeRange = x;
}
export { $t_Lpresto_types$RuleKind$__TimeRange as $t_Lpresto_types$RuleKind$__TimeRange, $u_Lpresto_types$RuleKind$__TimeRange as $u_Lpresto_types$RuleKind$__TimeRange };
var $t_Lpresto_types$RuleKind$__DaysInWeek = null;
function $u_Lpresto_types$RuleKind$__DaysInWeek(x) {
  $t_Lpresto_types$RuleKind$__DaysInWeek = x;
}
export { $t_Lpresto_types$RuleKind$__DaysInWeek as $t_Lpresto_types$RuleKind$__DaysInWeek, $u_Lpresto_types$RuleKind$__DaysInWeek as $u_Lpresto_types$RuleKind$__DaysInWeek };
//# sourceMappingURL=presto.types$-Rule-Kind$.js.map
